export const SET_CALENDAR_SETTINGS_ONLY = "SET_CALENDAR_SETTINGS_ONLY";
export const SET_SEARCH = "SET_SEARCH";

export const SET_CURRENT_YEAR_ONLY = "SET_CURRENT_YEAR_ONLY";
export const SET_CURRENT_MONTH_ONLY = "SET_CURRENT_MONTH_ONLY";
export const SET_CURRENT_DATE_TO_TODAY_ONLY = "SET_CURRENT_DATE_TO_TODAY_ONLY";
export const SET_CURRENT_DATE_TO_PREVIOUS_PERIOD_ONLY = "SET_CURRENT_DATE_TO_PREVIOUS_PERIOD_ONLY";
export const SET_CURRENT_DATE_TO_NEXT_PERIOD_ONLY = "SET_CURRENT_DATE_TO_NEXT_PERIOD_ONLY";
export const SET_CURRENT_DATE_ONLY = "SET_CURRENT_DATE_ONLY";

export const SET_SELECTED_DATE_ONLY = "SET_SELECTED_DATE_ONLY";

export const SET_VIEW_MODE_ONLY = "SET_VIEW_MODE_ONLY";
export const SET_EVENT_SCREEN_MODE_ONLY = "SET_EVENT_SCREEN_MODE_ONLY";

export const SET_EVENT_ID = "SET_EVENT_ID";

export const SET_ICAL_START_DATE = "SET_ICAL_START_DATE";

export const SET_DISPLAYED_EVENT_START_DATE = "SET_DISPLAYED_EVENT_START_DATE";
export const SET_DISPLAYED_EVENT_END_DATE = "SET_DISPLAYED_EVENT_END_DATE";

export const UPDATE_TO_AND_FROM_DATES = "UPDATE_TO_AND_FROM_DATES";

export const LOAD_CALENDAR_SETTINGS_SUCCESS = "LOAD_CALENDAR_SETTINGS_SUCCESS";
export const LOAD_CALENDAR_EVENTS_SUCCESS = "LOAD_CALENDAR_EVENTS_SUCCESS";
export const LOAD_CALENDAR_EVENT_DETAIL_SUCCESS = "LOAD_CALENDAR_EVENT_DETAIL_SUCCESS";

export const CLEAR_CALENDAR_EVENTS = "CLEAR_CALENDAR_EVENTS";

export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";

export const WIDTH_CHANGED = "WIDTH_CHANGED";

export const CLEAR_CURRENT_EVENT = "CLEAR_CURRENT_EVENT";

// Select events from other calendars:
export const SET_OPEN_SELECT_EVENTS_FROM_OTHER_CALENDARS_MODAL = "SET_OPEN_SELECT_EVENTS_FROM_OTHER_CALENDARS_MODAL";
export const REQUEST_SERVERS_FOR_CALENDAR_SUCCESS = "REQUEST_SERVERS_FOR_CALENDAR_SUCCESS";
export const UPDATE_SERVERS_SITES_PAGES_AND_CALENDARS = "UPDATE_SERVERS_SITES_PAGES_AND_CALENDARS";
export const UPDATE_EXPANDED_NODE_ITEM_IDS = "UPDATE_EXPANDED_NODE_ITEM_IDS";
export const UPDATE_CHECKED_NODE_ITEM_IDS = "UPDATE_CHECKED_NODE_ITEM_IDS";
export const UPDATE_CHECKED_NODE_CALENDAR_IDS = "UPDATE_CHECKED_NODE_CALENDAR_IDS";
export const UPDATE_SELECT_EVENTS_PAGER_PAGE_NUMBER = "UPDATE_SELECT_EVENTS_PAGER_PAGE_NUMBER";

// Registration
export const UNREGISTER_FROM_EVENT_SUCCESS = "UNREGISTER_FROM_EVENT_SUCCESS";

// Event deletion
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";

// Add/Edit Event Screen:
export const ADD_OR_EDIT_EVENT_CLEAR_ERROR_MESSAGE = "ADD_OR_EDIT_EVENT_CLEAR_ERROR_MESSAGE";
export const ADD_OR_EDIT_EVENT_ERROR_SUCCESS = "ADD_OR_EDIT_EVENT_ERROR_SUCCESS";
export const LOAD_CALENDAR_SETTINGS_ADD_EDIT_EVENT_SUCCESS = "LOAD_CALENDAR_SETTINGS_ADD_EDIT_EVENT_SUCCESS";
export const SET_DATE_OF_FIRST_EVENT_IN_RECURRENCE = "SET_DATE_OF_FIRST_EVENT_IN_RECURRENCE";
export const SET_START_DATE = "SET_START_DATE";

// Event Recurrence settings modal:
export const CLEAR_UPDATED_RECURRENCE_PATTERN = "CLEAR_UPDATED_RECURRENCE_PATTERN";
export const CLEAR_UPDATED_RECURRENCE_PATTERN_DESCRIPTION = "CLEAR_UPDATED_RECURRENCE_PATTERN_DESCRIPTION";
export const LOAD_UPDATED_RECURRENCE_PATTERN_DESCRIPTION_SUCCESS = "LOAD_UPDATED_RECURRENCE_PATTERN_DESCRIPTION_SUCCESS";
export const SET_OPEN_RECURRENCE_MODAL = "SET_OPEN_RECURRENCE_MODAL";
export const UPDATE_RECURRENCE_PATTERN = "UPDATE_RECURRENCE_PATTERN";
